import type { Config, State } from '../types'

export abstract class AbstractMessageHandler {
  constructor(
    protected readonly config: Config,
    protected readonly state: State,
    protected readonly sendMessageToButton: (type: string, payload: Record<string, unknown>) => void,
    protected readonly sendMessageToChat: (type: string, payload: Record<string, unknown>) => void,
    protected readonly toggleChat: () => void,
    protected readonly dismissGreeting: () => void,
    protected readonly scheduleGreeting: () => void,
    protected readonly logError: (message: string, ...args: unknown[]) => void,
    protected readonly showError: (message: string) => void
  ) {}

  abstract handle(event: MessageEvent, type: string, payload?: Record<string, unknown>): void
}
